import React, { useEffect, useRef } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import DesktopBackground from "./components/DesktopBackground";
import Window98 from "./components/Window98";
import { WindowManagerProvider, useWindowManager } from "./components/WindowManager";
import { VolumeProvider, useVolume } from "./components/VolumeContext";
import { APPS } from "./apps";
import { Analytics } from "@vercel/analytics/react";

// Every open window stays mounted, even when mobile hides it, so its state survives a resize.
const Windows = () => {
  const { state } = useWindowManager();
  return state.open.map((id) => <Window98 key={id} app={APPS[id]} />);
};

const ClickSounds = () => {
  const { effective } = useVolume();
  // Read through a ref so volume changes don't re-bind the document listeners.
  const volumeRef = useRef(effective);

  useEffect(() => {
    volumeRef.current = effective;
  }, [effective]);

  useEffect(() => {
    const clickDownSound = new Audio("/sounds/mouse-click-down.wav");
    const clickUpSound = new Audio("/sounds/mouse-click-up.wav");

    const playSound = (sound) => {
      if (volumeRef.current === 0) return;
      sound.volume = volumeRef.current;
      sound.currentTime = 0;
      sound.play().catch((err) => console.error("Failed to play sound:", err));
    };

    let lastPointerDown = 0;

    const handlePointerDown = () => {
      lastPointerDown = Date.now();
      playSound(clickDownSound);
    };

    const handleMouseUp = () => {
      const timeSincePointerDown = Date.now() - lastPointerDown;
      if (timeSincePointerDown > 100) {
        playSound(clickUpSound);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return null;
};

const App = () => {
  return (
    <Router>
      <Analytics/>
      <VolumeProvider>
        <ClickSounds />
        <WindowManagerProvider>
          {/* dvh, not vh: mobile Safari's 100vh extends under its toolbar, hiding the bottom of the page */}
          <div className="h-dvh w-screen overflow-hidden relative">
            {/* Render Desktop Background only on larger screens */}
            <div className="hidden lg:block absolute inset-0">
              <DesktopBackground />
            </div>

            {/* Windows */}
            <div
              className="
                flex items-center justify-center
                h-full w-full
                z-10
                relative
                pointer-events-none /* Let the desktop receive events outside the windows */
                lg:top-[-3vh] /* Adjust vertical position for lg and larger screens */
              "
            >
              <Windows />
            </div>
          </div>
        </WindowManagerProvider>
      </VolumeProvider>
    </Router>

  );

}
export default App;
